import { gql } from "gql";

export const GET_BPM_ROLE_ASSIGNMENT_TO_EDIT = gql(/* GraphQL */ `
  query GetBpmRoleAssignmentToEdit($id: ID!) {
    getHrRoleAssignmentById(id: $id) {
      id
      role {
        id
      }
      person {
        ... on PersonDto {
          id
        }
        ... on Hidden {
          ...Hidden
        }
      }
      hierarchyElement {
        id
      }
    }
  }
`);
